import { makeStyles } from "tss-react/mui";
import { settingsPageStyles } from "component/shared/settings-page";

export const useBillingStyles = makeStyles()((theme) => ({
	...settingsPageStyles(theme),
	value: {
		fontSize: 16,
		color: theme.palette.custom.textPrimary,
	},
	detailList: {
		display: "flex",
		flexDirection: "column",
		gap: 16,
	},
	inlineRow: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		gap: 16,
	},
	link: {
		display: "inline-flex",
		alignItems: "center",
		gap: 4,
		fontWeight: "bold",
		fontSize: 16,
		color: theme.palette.custom.tertiaryAction,
	},
	alert: {
		marginBottom: 16,
	},
	skeleton: {
		marginBottom: 16,
		borderRadius: 8,
	},
	// Recurly mounts each card field as an iframe inside a `.recurly-element` div; size and border
	// it like a FormField input (48px), since the iframe itself can only take text styles.
	recurlyField: {
		"& .recurly-element": {
			height: 48,
			width: "100%",
			margin: 0,
			boxSizing: "border-box",
			backgroundColor: "white",
			border: `1px solid ${theme.palette.custom.border}`,
			borderRadius: 4,
		},
		"& .recurly-element-focus": {
			border: `2px solid ${theme.palette.secondary.main}`,
		},
		"& .recurly-element-invalid": {
			border: `1px solid ${theme.palette.error.main}`,
		},
	},
	recurlyFieldError: {
		"& .recurly-element, & .recurly-element-focus": {
			borderColor: theme.palette.error.main,
		},
	},
	// The month and year elements share one bordered box so they read as a single MM/YY field.
	// Listed after recurlyField so its element borders are the ones removed.
	recurlyPair: {
		display: "flex",
		alignItems: "center",
		height: 48,
		boxSizing: "border-box",
		backgroundColor: "white",
		border: `1px solid ${theme.palette.custom.border}`,
		borderRadius: 4,
		"&:focus-within": {
			border: `2px solid ${theme.palette.secondary.main}`,
		},
		"& .recurly-element, & .recurly-element-focus, & .recurly-element-invalid": {
			height: 46,
			border: "none",
			backgroundColor: "transparent",
		},
	},
	recurlyPairError: {
		borderColor: theme.palette.error.main,
		"&:focus-within": {
			borderColor: theme.palette.error.main,
		},
	},
	recurlyPairHalf: {
		flex: 1,
		minWidth: 0,
	},
	recurlyPairSeparator: {
		fontSize: 16,
		color: theme.palette.custom.textSecondary,
	},
	fieldLabel: {
		display: "block",
		marginBottom: 8,
		fontSize: "0.875rem",
		lineHeight: "20px",
		color: theme.palette.custom.textSecondary,
	},
	divider: {
		margin: "8px 0",
	},
	paymentOnFile: {
		fontSize: 16,
		marginBottom: 16,
		color: theme.palette.custom.textPrimary,
	},
	fieldError: {
		margin: "0.25rem 0.875rem 0",
		fontSize: "0.75rem",
		color: theme.palette.error.main,
	},
}));
